import React from 'react';

import './MaterialReactTable.scss';
import './TableCell.scss';
import clsx from 'clsx';
import { numberFormatter } from '../../utils/utilities';

type Props = {
	isPositive: boolean;
	cellWidth?: string;
	currencySymbol?: string;
	currencyCode?: string;
	value: number;
	total?: number;
}

export const CellWithCurrency = (props: Props): React.ReactElement => {
	const { isPositive, cellWidth, currencySymbol, currencyCode, value, total } = props;

	if (isPositive || value === 0) {
		return (
			<div
				className={clsx(
					'fc-text-overflow',
					total > 0 && 'd-flex align-items-start',
					cellWidth ?? ''
				)}
			>
				<div className={clsx(total && 'me-2')}>
					<div className="text-dark fw-bolder fs-8 fc-text-overflow">
						{`${currencySymbol ? currencySymbol : ''}${numberFormatter(value)}`}
					</div>
					{currencyCode && (
						<div className="text-muted fs-9">
							{currencyCode}
						</div>
					)}
				</div>
				{Boolean(total) && (
					<div className="fw-bolder text-dark fs-8">/ {total}</div>
				)}
			</div>
		);
	}

	return (
		<div
			className={clsx(
				'fc-text-overflow',
				total > 0 && 'd-flex align-items-start',
				cellWidth ?? ''
			)}
		>
			<div className={clsx('fc-text-overflow', total && 'me-2')}>
	      <span className={clsx('fw-bolder fs-8 text-danger ')}>
	        {currencySymbol}
	      </span>
				<span className={clsx('fw-bolder fs-8 text-danger')}>
	        {value > 0 ? `(${numberFormatter(value)})` : `(${numberFormatter(value * -1)})`}
	      </span>
				<div className={clsx('fs-9', isPositive ? 'text-muted' : 'text-danger')}>
					{currencyCode}
				</div>
			</div>
			{Boolean(total) && (
				<div className="fw-bolder text-dark fs-8">/ {total}</div>
			)}
		</div>
	);
};
